// we never want default submit refresh
window.addEventListener('submit', e => {
  e.preventDefault();
});
